/**
 * Progression Types — Job advancement, talents, and professions.
 * Extracted from CharacterTypes.ts during 2026-03-17 tech debt audit.
 */

import type { CharacterClass, Ability, CharacterStats } from '../CharacterTypes';
import type { Position } from '../LevelTypes';

// Job/Class Advancement System
export enum JobClass {
  // Warrior Path
  WARRIOR_BASIC = 'warrior_basic',
  SWORDSMAN = 'swordsman',
  CRUSADER = 'crusader',
  HERO = 'hero',

  // Mage Path
  MAGE_BASIC = 'mage_basic',
  WIZARD = 'wizard',
  ARCHMAGE = 'archmage',

  // Ranger Path
  RANGER_BASIC = 'ranger_basic',
  HUNTER = 'hunter',
  RANGER_LORD = 'ranger_lord',

  // Paladin Path
  PALADIN_BASIC = 'paladin_basic',
  KNIGHT = 'knight',
  PALADIN_LORD = 'paladin_lord',

  // Thief/Assassin Path
  THIEF = 'thief',           // 1st job (level 10)
  ASSASSIN = 'assassin',     // 2nd job (level 30)
  HERMIT = 'hermit',         // 3rd job (level 70)
  NIGHT_LORD = 'night_lord',  // 4th job (level 120)

  // Shaman Path
  SHAMAN_BASIC = 'shaman_basic',
  ELEMENTALIST = 'elementalist',
  SPIRIT_WALKER = 'spirit_walker',
  SHAMAN_LORD = 'shaman_lord'
}

export interface JobAdvancement {
  job: JobClass;
  name: string;
  description: string;
  requiredLevel: number;
  requiredClass: CharacterClass;
  abilities: Ability[];
  statBonuses: Partial<CharacterStats>;
  color: string;
}

// Talent/Skill Tree System
export interface TalentNode {
  id: string;
  name: string;
  description: string;
  icon?: string;
  maxRank: number;
  currentRank: number;
  cost: number;
  prerequisites: string[];
  effects: TalentEffect[];
}

export interface TalentEffect {
  type: 'stat_bonus' | 'ability_mod' | 'passive' | 'unlock_ability';
  target: string;
  value: number;
  perRank?: boolean;
}

export interface TalentTree {
  [treeName: string]: TalentNode[];
}

// Profession System
export enum ProfessionType {
  MINING = 'mining',
  HERBALISM = 'herbalism',
  FISHING = 'fishing',
  BLACKSMITHING = 'blacksmithing',
  ALCHEMY = 'alchemy',
  TAILORING = 'tailoring',
  JEWELCRAFTING = 'jewelcrafting'
}

export interface Profession {
  type: ProfessionType;
  name: string;
  level: number;
  xp: number;
  maxLevel: number;
  recipes: string[];
}

// Training System
export interface TrainingDummy {
  id: string;
  name: string;
  type: 'basic' | 'advanced' | 'boss';
  health: number;
  maxHealth: number;
  level: number;
  position: Position;
  respawnTime: number;
  trainingBonus: number;
}
